// eslint-disable-next-line import/prefer-default-export
export const BULK_REQUEST_LIMIT = 20;
export const DATA_START_ROW = 3;
export const HEADER_ROW_COUNT = 2;

export const ERROR_TOO_MUCH_ROWS = 'ERROR_TOO_MUCH_ROWS';
